import useAIConfigs from "@/hooks/useAIConfigs";
import useApi from "@/hooks/useApi";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AIConfiguration } from "../types";

export default function CreateChatbotButton() {
  const { aiConfigurations, add, update } = useAIConfigs();
  const api = useApi();
  const [creating, setCreating] = useState(false);
  const navigate = useNavigate();
  const pendingConfigRef = useRef<AIConfiguration | null>(null);

  function handleCreate() {
    const newConfig = add();
    pendingConfigRef.current = newConfig;
    setCreating(true);
  }

  useEffect(() => {
    const saveAi = async () => {
      const pendingConfig = pendingConfigRef.current;
      if (!creating || !pendingConfig || pendingConfig.id !== 0) {
        return;
      }

      const response = await api.messaging.post("AIConfiguration", pendingConfig);
      if (response.ok) {
        const savedConfig = await response.json();
        // Find the index of the pending config by reference
        const index = aiConfigurations.indexOf(pendingConfig);
        if (index !== -1) {
          update(savedConfig, index);
        }
        // Save initial version snapshot (non-fatal)
        try {
          if (savedConfig?.id) {
            await api.admin.post("AIConfigurationVersions", {
              aiConfigId: savedConfig.id,
              configName: savedConfig.name ?? "",
              configJson: JSON.stringify(savedConfig),
              changeType: "Created"
            });
          }
        } catch { /* version failure must never block navigation */ }
        navigate(`/ai/settings/general/${savedConfig.id}`);
      }
      pendingConfigRef.current = null;
      setCreating(false);
    };
    saveAi();
  }, [creating, aiConfigurations, api.messaging, navigate, update]);

  return (
    <PrimaryBlueButton
      label="+ Create Chatbot"
      onClick={handleCreate}
      disabled={creating}
    />
  );
}
